import Modal from '@mui/material/Modal'
import CustomPaper from './Paper'
import { ReactNode } from 'react'

type ModalProps = {
    isOpen: boolean
    handleClose: () => void
    children: ReactNode
    onBackdropClick?: () => void
}
function CustomModal({ isOpen, handleClose, children, onBackdropClick }: ModalProps) {
    return (
        <Modal
            aria-describedby="modal-modal-description"
            aria-labelledby="modal-modal-title"
            className="flex items-center justify-center"
            open={isOpen}
            onClose={(event, reason) => {
                if (onBackdropClick !== undefined && reason === 'backdropClick') {
                    onBackdropClick()
                } else handleClose()
            }}
        >
            <div>
                <CustomPaper className="w-fit h-fit">
                    <div className="p-1 w-fit h-fit overflow-auto">{children}</div>
                </CustomPaper>
            </div>
        </Modal>
    )
}

export default CustomModal
